export default "__VITE_ASSET__4TwKdlAO__"